import { createFileRoute } from '@tanstack/react-router';

import { SyncJobsPage } from '@pages/sync';

/**
 * Sync - Jobs
 *
 * Route: /:locale/sync/jobs
 */
export const Route = createFileRoute('/$locale/_authenticated/sync/jobs')({
  component: SyncJobsRoute,
});

function SyncJobsRoute() {
  return <SyncJobsPage />;
}
